import React from "react";
import ShiftCard from "./ShiftCard";
import NewShiftCard from "./NewShiftCard";
import UnavailableCard from "./UnavailableCard";
import UnavailableVacationCard from "./UnavailableVacationCard";
import UnassignedRoles from "./UnassignedRoles";
import OtherStoreCard from "./OtherStoreCard";
import FilteredDepartmentShiftCard from "./FilteredDepartmentShiftCard";
import OtherStoreShiftMarker from "./OtherStoreShiftMarker";
import { get_t_str_shortened } from "../../../../helpers/helpers";

function PersonDayShiftDisplay(props) {
  const locked_mode =
    !props.edit_mode | props.displayMode | props.locked_person;
  const canCreatePastShifts = props.day_in_past && props.editShiftsInPastEnabled;

  const renderWithOutsideShift = (content) => {
    if (!props.person_day_out_of_filter_shifts?.length) return content;

    return (
      <div className="relative h-full w-full">
        {content}
        <FilteredDepartmentShiftCard
          shifts={props.person_day_out_of_filter_shifts}
          roleNames={props.role_names}
          getTime={props.get_t_str}
          compact
          minimizeMode={props.minimizeMode}
          onLightCard
        />
      </div>
    );
  };

  // Actual mode shows what happened and nothing else. Availability, time off,
  // other-store shifts, out-of-department shifts and the add-shift placeholder
  // are all plan, so an empty cell stays empty rather than filling with them.
  if (props.showActualTimes && !(props.person_day_shift?.length > 0)) {
    // Time off is a record of the day, not a plan for it: it is the reason
    // there is no work here, so hiding it turned an explained absence into a
    // blank row.
    if (props.person_day_time_off_requests?.length > 0) {
      // Someone can be on approved time off and still clock in, so the marker
      // for work in a hidden department rides along with the vacation card
      // rather than being displaced by it.
      return renderWithOutsideShift(
        <UnavailableVacationCard
          readOnly
          weekly_or_daily="weekly"
          p={props.p}
          date_str={props.date_str}
          store_id={props.store_id}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability?.[0]}
          role_names={props.role_names}
          d={props.d}
          minimizeMode={props.minimizeMode}
          role_types={props.role_types}
          person_day_time_off_requests={props.person_day_time_off_requests}
          windowWidth={props.windowWidth}
        />
      );
    }
    // Work in a department the selector has hidden still leaves its marker, so
    // an empty cell means nobody worked rather than nobody worked here.
    if (props.person_day_out_of_filter_shifts?.length > 0) {
      return (
        <FilteredDepartmentShiftCard
          shifts={props.person_day_out_of_filter_shifts}
          roleNames={props.role_names}
          getTime={props.get_t_str}
        />
      );
    }
    return <div className="w-full h-full" />;
  }

  if ((props.person_day_shift?.length === 0) & !locked_mode) {
    if (props.person_day_time_off_requests?.length > 0) {
      return renderWithOutsideShift(
        <UnavailableVacationCard
          weekly_or_daily="weekly"
          p={props.p}
          date_str={props.date_str}
          addShift={props.addShift}
          store_id={props.store_id}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability[0]}
          role_names={props.role_names}
          saveShiftFinished={props.saveShiftFinished}
          setSaveShiftFinished={props.setSaveShiftFinished}
          d={props.d}
          copiedShift={props.copiedShift}
          setCopiedShift={props.setCopiedShift}
          addMultipleShifts={props.addMultipleShifts}
          minimizeMode={props.minimizeMode}
          role_types={props.role_types}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          frequentShifts={props.frequentShifts}
          hasNoCapableRoles={props.p.available_role_info.length === 0}
          updatePersonInfo={props.updatePersonInfo}
          breakWaiverEnabled={props.breakWaiverEnabled}
          person_day_time_off_requests={props.person_day_time_off_requests}
          defaultBreakLengthHours={props.defaultBreakLengthHours}
          breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
          secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
          restBreakRegulation={props.restBreakRegulation}
        />
      );
    } else if (
      // props.person_day_availability.length === 0 ||
      props.person_day_availability?.[0]?.available_to === 0
    ) {
      return renderWithOutsideShift(
        <UnavailableCard
          weekly_or_daily="weekly"
          p={props.p}
          date_str={props.date_str}
          addShift={props.addShift}
          store_id={props.store_id}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability[0]}
          role_names={props.role_names}
          saveShiftFinished={props.saveShiftFinished}
          setSaveShiftFinished={props.setSaveShiftFinished}
          d={props.d}
          copiedShift={props.copiedShift}
          setCopiedShift={props.setCopiedShift}
          addMultipleShifts={props.addMultipleShifts}
          minimizeMode={props.minimizeMode}
          role_types={props.role_types}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          frequentShifts={props.frequentShifts}
          hasNoCapableRoles={props.p.available_role_info.length === 0}
          updatePersonInfo={props.updatePersonInfo}
          breakWaiverEnabled={props.breakWaiverEnabled}
          defaultBreakLengthHours={props.defaultBreakLengthHours}
          breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
          secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
                    restBreakRegulation={props.restBreakRegulation}
        />
      );
      // } else if (props.p.available_role_info.length === 0) {
      //   return <UnassignedRoles />;
    } else if (props.person_day_other_store_shift?.length > 0) {
      return (
        <div className="relative h-full w-full">
          <OtherStoreCard
          weekly_or_daily="weekly"
          p={props.p}
          date_str={props.date_str}
          addShift={props.addShift}
          store_id={props.store_id}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability[0]}
          other_store_shift_info={props.person_day_other_store_shift}
          role_names={props.role_names}
          saveShiftFinished={props.saveShiftFinished}
          setSaveShiftFinished={props.setSaveShiftFinished}
          d={props.d}
          copiedShift={props.copiedShift}
          setCopiedShift={props.setCopiedShift}
          addMultipleShifts={props.addMultipleShifts}
          minimizeMode={props.minimizeMode}
          role_types={props.role_types}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          frequentShifts={props.frequentShifts}
          hasNoCapableRoles={props.p.available_role_info.length === 0}
          updatePersonInfo={props.updatePersonInfo}
          breakWaiverEnabled={props.breakWaiverEnabled}
          day_in_past={props.day_in_past}
          defaultBreakLengthHours={props.defaultBreakLengthHours}
          breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
          secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
            restBreakRegulation={props.restBreakRegulation}
          />
          {props.person_day_out_of_filter_shifts?.length > 0 && (
            <FilteredDepartmentShiftCard
              shifts={props.person_day_out_of_filter_shifts}
              roleNames={props.role_names}
              getTime={props.get_t_str}
              compact
              minimizeMode={props.minimizeMode}
              onLightCard
            />
          )}
        </div>
      )
    } else if (props.person_day_out_of_filter_shifts?.length > 0) {
      return (
        <FilteredDepartmentShiftCard
          shifts={props.person_day_out_of_filter_shifts}
          roleNames={props.role_names}
          getTime={props.get_t_str}
        />
      );
    } else {
      return (
        <NewShiftCard
          weekly_or_daily="weekly"
          p={props.p}
          date_str={props.date_str}
          addShift={props.addShift}
          store_id={props.store_id}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability[0]}
          role_names={props.role_names}
          saveShiftFinished={props.saveShiftFinished}
          setSaveShiftFinished={props.setSaveShiftFinished}
          d={props.d}
          copiedShift={props.copiedShift}
          setCopiedShift={props.setCopiedShift}
          addMultipleShifts={props.addMultipleShifts}
          minimizeMode={props.minimizeMode}
          role_types={props.role_types}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          frequentShifts={props.frequentShifts}
          edit_mode={props.edit_mode}
          hasNoCapableRoles={props.p.available_role_info.length === 0}
          updatePersonInfo={props.updatePersonInfo}
          breakWaiverEnabled={props.breakWaiverEnabled}
          person_day_time_off_requests={props.person_day_time_off_requests}
          defaultBreakLengthHours={props.defaultBreakLengthHours}
          breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
          secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
                    restBreakRegulation={props.restBreakRegulation}
        />
      );
    }
  } else if (props.person_day_shift?.length > 0) {
    return (
      <div className="relative h-full w-full">
        <ShiftCard
          actualWarningsByEntry={props.actualWarningsByEntry}
          weekly_or_daily="weekly"
          shifts_info={props.person_day_shift}
          shift_info={props.person_day_shift[0]}
          lockAllShifts={props.lockAllShifts}
          p={props.p}
          locked_mode={locked_mode || props.lockAllShifts}
          addShift={props.addShift}
          get_t_str={props.get_t_str}
          date_name={props.date_name}
          availability_info={props.person_day_availability[0]}
          role_names={props.role_names}
          saveShiftFinished={props.saveShiftFinished}
          setSaveShiftFinished={props.setSaveShiftFinished}
          d={props.d}
          setCopiedShift={props.setCopiedShift}
          copiedShift={props.copiedShift}
          minimizeMode={props.minimizeMode}
          time_off_conflict={props.person_day_time_off_requests.length > 0}
          role_types={props.role_types}
          addMultipleShifts={props.addMultipleShifts}
          businessWeekStartDayIndex={props.businessWeekStartDayIndex}
          start_qhnum={props.start_qhnum}
          schedule_day_end_qhnum={props.schedule_day_end_qhnum}
          storeTimezone={props.storeTimezone}
          frequentShifts={props.frequentShifts}
          day_in_past={props.day_in_past}
          post_missed_shift={props.post_missed_shift}
          breakWaiverEnabled={props.breakWaiverEnabled}
          showUnpublishedShifts={props.showUnpublishedShifts}
          person_day_time_off_requests={props.person_day_time_off_requests}
          defaultBreakLengthHours={props.defaultBreakLengthHours}
          editShiftsInPastEnabled={props.editShiftsInPastEnabled}
          isCopilotOn={props.isCopilotOn}
          showActualTimes={props.showActualTimes}
          actualTimesByPublishedId={props.actualTimesByPublishedId}
          coveredPublishedIds={props.coveredPublishedIds}
          coverageOwners={props.coverageOwners}
          breakRequiredWhenShiftLengthExceeds={
            props.breakRequiredWhenShiftLengthExceeds
          }
          secondBreakShiftLengthThreshold={
            props.secondBreakShiftLengthThreshold
          }
          paidBreakInputsEnabled={props.paidBreakInputsEnabled}
          businessDeclineShiftOptionEnabled={
            props.businessDeclineShiftOptionEnabled
          }
          restBreakRegulation={props.restBreakRegulation}
          windowWidth={props.windowWidth}
          laborLawViolations={props.laborLawViolations}
          // Rendered inside the card, beside its warning icon, so a click,
          // drag or right-click that lands on them still reaches the card,
          // and they hide with its icons while the action buttons are open.
          cornerMarkers={
            <>
              {/* Other-store shifts are plan, so actual mode leaves them out
                  as it does for an empty cell. */}
              {!props.showActualTimes && (
                <OtherStoreShiftMarker
                  ownShifts={props.person_day_shift}
                  otherStoreShifts={props.person_day_other_store_shift}
                  getTime={get_t_str_shortened}
                  minimizeMode={props.minimizeMode}
                />
              )}
              {props.person_day_out_of_filter_shifts?.length > 0 && (
                <FilteredDepartmentShiftCard
                  shifts={props.person_day_out_of_filter_shifts}
                  roleNames={props.role_names}
                  getTime={props.get_t_str}
                  compact
                  minimizeMode={props.minimizeMode}
                  besideOtherStoreMarker={
                    !props.showActualTimes &&
                    props.person_day_other_store_shift?.length > 0
                  }
                />
              )}
            </>
          }
        />
      </div>
    );
  } else if (
    props.person_day_out_of_filter_shifts?.length > 0 &&
    props.person_day_other_store_shift?.length === 0
  ) {
    return (
      <FilteredDepartmentShiftCard
        shifts={props.person_day_out_of_filter_shifts}
        roleNames={props.role_names}
        getTime={props.get_t_str}
      />
    );
  } else if (props.person_day_other_store_shift?.length > 0) {
    return (
      <div className="relative h-full w-full">
        <OtherStoreCard
        weekly_or_daily="weekly"
        p={props.p}
        date_str={props.date_str}
        addShift={props.addShift}
        store_id={props.store_id}
        get_t_str={props.get_t_str}
        date_name={props.date_name}
        availability_info={props.person_day_availability[0]}
        other_store_shift_info={props.person_day_other_store_shift}
        role_names={props.role_names}
        saveShiftFinished={props.saveShiftFinished}
        setSaveShiftFinished={props.setSaveShiftFinished}
        d={props.d}
        copiedShift={props.copiedShift}
        setCopiedShift={props.setCopiedShift}
        addMultipleShifts={props.addMultipleShifts}
        minimizeMode={props.minimizeMode}
        role_types={props.role_types}
        businessWeekStartDayIndex={props.businessWeekStartDayIndex}
        start_qhnum={props.start_qhnum}
        schedule_day_end_qhnum={props.schedule_day_end_qhnum}
        frequentShifts={props.frequentShifts}
        hasNoCapableRoles={props.p.available_role_info.length === 0}
        updatePersonInfo={props.updatePersonInfo}
        breakWaiverEnabled={props.breakWaiverEnabled}
        day_in_past={props.day_in_past}
        defaultBreakLengthHours={props.defaultBreakLengthHours}
        breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
        secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
        paidBreakInputsEnabled={props.paidBreakInputsEnabled}
        businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
          restBreakRegulation={props.restBreakRegulation}
        />
        {props.person_day_out_of_filter_shifts?.length > 0 && (
          <FilteredDepartmentShiftCard
            shifts={props.person_day_out_of_filter_shifts}
            roleNames={props.role_names}
            getTime={props.get_t_str}
            compact
            minimizeMode={props.minimizeMode}
            onLightCard
          />
        )}
      </div>
    )
  } else if (canCreatePastShifts) {
    return (
      <NewShiftCard
        weekly_or_daily="weekly"
        p={props.p}
        date_str={props.date_str}
        addShift={props.addShift}
        store_id={props.store_id}
        get_t_str={props.get_t_str}
        date_name={props.date_name}
        availability_info={props.person_day_availability[0]}
        role_names={props.role_names}
        saveShiftFinished={props.saveShiftFinished}
        setSaveShiftFinished={props.setSaveShiftFinished}
        d={props.d}
        copiedShift={props.copiedShift}
        setCopiedShift={props.setCopiedShift}
        addMultipleShifts={props.addMultipleShifts}
        minimizeMode={props.minimizeMode}
        role_types={props.role_types}
        businessWeekStartDayIndex={props.businessWeekStartDayIndex}
        start_qhnum={props.start_qhnum}
        schedule_day_end_qhnum={props.schedule_day_end_qhnum}
        frequentShifts={props.frequentShifts}
        edit_mode={props.edit_mode}
        hasNoCapableRoles={props.p.available_role_info.length === 0}
        updatePersonInfo={props.updatePersonInfo}
        breakWaiverEnabled={props.breakWaiverEnabled}
        person_day_time_off_requests={props.person_day_time_off_requests}
        defaultBreakLengthHours={props.defaultBreakLengthHours}
        breakRequiredWhenShiftLengthExceeds={props.breakRequiredWhenShiftLengthExceeds}
        secondBreakShiftLengthThreshold={props.secondBreakShiftLengthThreshold}
        showPlaceholder={false}
        paidBreakInputsEnabled={props.paidBreakInputsEnabled}
        businessDeclineShiftOptionEnabled={props.businessDeclineShiftOptionEnabled}
                    restBreakRegulation={props.restBreakRegulation}
      />
    );
  } else {
    return <div></div>;
  }
}

export default PersonDayShiftDisplay;
